import store from 'Data/store';
import config from 'config.json';

const getShortUrl = async (url, metadata, signal) => {
    const clientId =
        store.getState()?.pageState?.layout?.config?.settings?.clientId ??
        store.getState()?.pageState?.dsm?.present?.settings?.clientId;
    return fetch(config.shortUrlService, {
        method: 'POST',
        body: JSON.stringify({
            url,
            metadata: {...metadata, clientId},
        }),
        signal,
    })
        .then(response => response.json())
        .then(data => {
            if (!data.error) {
                return new URL(`${config.shortUrlService}/${data.hash}`, document.location).href;
            }
            return url;
        })
        .catch(() => url);
};

/**
 * @param urlsWithMetadata Array of {url, metadata} objects
 * @param signal
 * @returns {Promise<any>}
 */
export const getShortUrls = async (urlsWithMetadata, signal) =>
    fetch(config.shortUrlService, {
        method: 'POST',
        body: JSON.stringify({urls: urlsWithMetadata}),
        signal,
    })
        .then(response => response.json())
        .then(data => {
            const shortUrls = {};
            if (!data.error && data.hashes instanceof Object) {
                Object.entries(data.hashes).forEach(([url, hash]) => {
                    shortUrls[url] = new URL(
                        `${config.shortUrlService}/${hash}`,
                        document.location
                    ).href;
                });
                return shortUrls;
            }
            return urlsWithMetadata;
        })
        .catch(() => urlsWithMetadata);

export default getShortUrl;
